import { render, staticRenderFns } from "./bonus-navbar-button.vue?vue&type=template&id=062e6953&scoped=true&"
import script from "./bonus-navbar-button.vue?vue&type=script&lang=ts&"
export * from "./bonus-navbar-button.vue?vue&type=script&lang=ts&"
import style0 from "./bonus-navbar-button.vue?vue&type=style&index=0&id=062e6953&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e6953",
  null
  
)

export default component.exports